import {doc, setDoc, Timestamp, increment} from 'firebase/firestore';
import {firestore, getCollectionPath} from '../config/Firebase';
import DateTime from './DateTime';
import Debug from './Debug';
import md5 from 'md5';

export default class PlaylistItemMetric {
    static incrementViewCount(playlistId, itemId, type, client, instance) {
        if (!playlistId || !itemId || !type || !client || !instance || !instance.id) {
            Debug.printToLog('error', 'incrementViewCount() is missing required data');
            return Promise.resolve();
        }
        const timestamp = Timestamp.now();
        const date = new Date(timestamp.seconds * 1000);
        const dateKey = DateTime.formatDate(date, true, '-', ['year', 'month', 'day']);
        const id = md5(`${instance.id}_${itemId}_${playlistId}`);
        const data = {
            instance: instance.id,
            itemId: itemId,
            playlistId: playlistId,
            client: client,
            type: type,
            views: {
                [dateKey]: increment(1)
            }
        };
        const _path = getCollectionPath(client, 'playlist_metrics');
        const _document = doc(firestore, _path, id);
        return setDoc(_document, data, {merge: true})
            .catch((error) => {
                Debug.printToLog('error', error);
            });
    };
}